import styled from "styled-components";
import { getColor, getSize, responsive } from "~/helpers/style";
import Button from "../ui/Button";

export const StepTitle = styled.h2`
  color: ${getColor("text")};
  font-size: ${getSize(1.8)};
  font-weight: 700;
  margin: 0;
  font-family: Ubuntu;

  ${responsive("tablet", true)} {
    font-size: ${getSize(1.2)};
  }

  ${responsive("tablet")} {
    font-size: ${getSize(1.4)};
    margin: ${getSize(1.3)} 0;
  }
`;

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  gap: ${getSize(2.0)};

  ${responsive("tablet", true)} {
    gap: ${getSize(1.0)};
  }

  ${responsive("tablet")} {
    grid-template-columns: 1fr 1fr;
    gap: ${getSize(2.0)};
  }
`;

export const CardCategory = styled.div`
  display: flex;
  gap: ${getSize(1.0)};
  padding: ${getSize(1.2)} ${getSize(2.3)};
  border: 1px solid ${getColor("border")};
  border-radius: ${getSize(0.8)};
  align-items: center;
  font-size: ${getSize(1.4)};
  color: ${getColor("text")};
  cursor: pointer;
  font-weight: 500;
  width: 100%;
  transition: border-color 0.2s;

  ${responsive("tablet", true)} {
    gap: ${getSize(0.6)};
    padding: ${getSize(0.6)} ${getSize(1.2)};
    border-radius: ${getSize(0.6)};
    font-size: ${getSize(1.1)};
  }

  ${responsive("tablet")} {
    font-size: ${getSize(1.6)};
    padding: ${getSize(1.8)} ${getSize(2.3)};
  }

  &:hover {
    background-color: ${getColor("background")};
    border: 0.74px solid #1a004d;
  }

  &.active {
    border: 1px solid ${getColor("primary")};
  }
`;

export const ButtonFixedContainer = styled.div`
  padding: ${getSize(1.3)};
  background-color: ${getColor("background")};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const LoadingContainer = styled.div`
  > div {
    height: 10px;
    width: 20px;
    top: 0;

    > svg {
      margin: unset !important;
    }
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  height: 180px;
  width: 100%;
  width: 400px;
  align-items: center;
  justify-content: center;
`;

export const SkipButton = styled(Button)`
  border: 1px solid #8383830f;
  box-shadow: 0px 1px 2px 0px #1018280d;
  color: var(--light-dark, #2e2e2e);
  font-weight: 500;

  :hover {
    background-color: ${getColor("background")};
  }
`;

export const CategoryModalContent = styled.div`
  white-space: nowrap;
`;

